import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import { Field } from "react-final-form";
import type { OptionType } from "./types";

interface ChipsProps {
  name: string;
  options: OptionType[];
  [key: string]: any;
}

export function Chips(props: ChipsProps) {
  const { options } = props;
  return (
    <Field
      name={props.name}
      render={({ input }) => (
        <Grid container spacing={1}>
          {options.map((option: OptionType, i: number) => (
            <Grid key={i}>
              <Chip
                label={option.label}
                color={option.value === input.value ? "primary" : "default"}
                onClick={() => {
                  input.onChange(
                    option.value === input.value ? undefined : option.value
                  );
                }}
                style={{
                  backgroundColor:
                    option.value === input.value ? option.color : undefined,
                }}
              />
            </Grid>
          ))}
        </Grid>
      )}
    />
  );
}
